<template>
  <div class="department-header">
    <div class="d-flex align-center justify-space-between">
      <div>
        <Breadcrumbs headline="Quản lý cơ sở" :link="[{ text: 'Quản lý cơ sở', href: '/departments' }]" />
      </div>
      <v-btn color="primary" @click="$emit('create')" elevation="0" class="px-6">
        <v-icon left>mdi-plus</v-icon>
        Thêm cơ sở mới
      </v-btn>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'

export default {
  name: 'DepartmentHeader',
  components: {
    Breadcrumbs,
  },
}
</script>

<style scoped>
.department-header {
  padding: 16px;
}
.headline {
  margin-bottom: 8px;
}
</style>
